// extracted by mini-css-extract-plugin
module.exports = {"sorting":"CampaignFollowUpPage_sorting__Yg15l","row":"CampaignFollowUpPage_row__3NMyG","handler":"CampaignFollowUpPage_handler__3b2-B"};